// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../app/providers/theme/colors.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../app/providers/theme/shadow.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HealthAI-module__mainBox--oWnRP {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
}

.HealthAI-module__container--ztaQj {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 70vh;
    padding: 20px;
    text-align: center;
}

/* Контейнер для заголовка */
.HealthAI-module__titleContainer--_elyl {
    /* padding: 16px; */
    display: flex;
    justify-content: center;
    margin: 20px 0;
}

/* Заголовок */
.HealthAI-module__title--WR_zp {
    text-align: center;
    font-size: 1.5rem;
}

/* Контейнер для текста шагов */
.HealthAI-module__stepsTextContainer--arCQc {
    display: flex;
    justify-content: space-between;
    padding: 0;
    margin-bottom: 8px;

}

/* Текст шага */
.HealthAI-module__stepText--CZEsH {
    font-size: 0.65rem;
    text-align: center;
    flex: 1;
    font-size: 13px !important;
}

/* Текст шага для десктопа */
.HealthAI-module__stepTextDesktop--gN5El {
    font-size: 0.875rem;
}

/* Активный текст шага */
.HealthAI-module__stepTextActive--tROpN {
    color: var(--primary-color);
}

/* Контейнер для Stepper */
.HealthAI-module__stepperContainer--vfGO0 {
    width: 100%;
    padding: 0;
}

/* Стили для Stepper */
.HealthAI-module__stepper--eGlQi {
    padding: 0;
}

/* Стили для шага */
.HealthAI-module__stepperStep--K0FDE {
    padding: 0;
    margin: 0;
}

/* Стили для иконки шага */
.HealthAI-module__stepperIcon--I3yQP {
    width: 20px;
    height: 20px;
    font-size: 0.75rem;
    margin: 0;
}

/* Стили для иконки шага на десктопе */
.HealthAI-module__stepperIconDesktop--ONFKj {
    width: 24px;
    height: 24px;
    font-size: 1rem;
}

/* Стили для соединительной линии */
.HealthAI-module__stepperConnectorLine--gieQ4 {
    min-height: 1px;
    margin: 0;
}

/* Стили для соединительной линии на десктопе */
.HealthAI-module__stepperConnectorLineDesktop--exCGZ {
    min-height: 2px;
}

/* Стили для метки шага */
.HealthAI-module__stepperLabel--nCbIr {
    padding: 0;
    margin: 0;
}

.HealthAI-module__title--WR_zp {
    color: #6F879C;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 30px;
}

/* Для уменьшения размера степпера */
.HealthAI-module__stepperContainer--vfGO0 .HealthAI-module__MuiStepper-root--uKj4X {
    padding: 8px 0;
}

.HealthAI-module__stepperContainer--vfGO0 .HealthAI-module__MuiStep-root--ReplF {
    padding: 0 4px;
}

.HealthAI-module__stepperContainer--vfGO0 .HealthAI-module__MuiStepIcon-root--_NPGL {
    width: 24px;
    height: 24px;
    font-size: 14px;
}

.HealthAI-module__btnBack--V9Nus {
    text-transform: none !important;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    height: 70px;
    gap: 10px;
    color: var(--color-primary-30) !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/health-ai/HealthAI.module.css"],"names":[],"mappings":"AAGA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;;AAEA,4BAA4B;AAC5B;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,cAAc;AAClB;;AAEA,cAAc;AACd;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,+BAA+B;AAC/B;IACI,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,kBAAkB;;AAEtB;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,kBAAkB;IAClB,OAAO;IACP,0BAA0B;AAC9B;;AAEA,4BAA4B;AAC5B;IACI,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,2BAA2B;AAC/B;;AAEA,0BAA0B;AAC1B;IACI,WAAW;IACX,UAAU;AACd;;AAEA,sBAAsB;AACtB;IACI,UAAU;AACd;;AAEA,mBAAmB;AACnB;IACI,UAAU;IACV,SAAS;AACb;;AAEA,0BAA0B;AAC1B;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;AACb;;AAEA,sCAAsC;AACtC;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA,mCAAmC;AACnC;IACI,eAAe;IACf,SAAS;AACb;;AAEA,+CAA+C;AAC/C;IACI,eAAe;AACnB;;AAEA,yBAAyB;AACzB;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,oCAAoC;AACpC;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,SAAS;IACT,yCAAyC;AAC7C","sourcesContent":["@import 'app/providers/theme/colors.css';\r\n@import 'app/providers/theme/shadow.css';\r\n\r\n.mainBox {\r\n    margin-top: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-content: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-height: 70vh;\r\n    padding: 20px;\r\n    text-align: center;\r\n}\r\n\r\n/* Контейнер для заголовка */\r\n.titleContainer {\r\n    /* padding: 16px; */\r\n    display: flex;\r\n    justify-content: center;\r\n    margin: 20px 0;\r\n}\r\n\r\n/* Заголовок */\r\n.title {\r\n    text-align: center;\r\n    font-size: 1.5rem;\r\n}\r\n\r\n/* Контейнер для текста шагов */\r\n.stepsTextContainer {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 0;\r\n    margin-bottom: 8px;\r\n\r\n}\r\n\r\n/* Текст шага */\r\n.stepText {\r\n    font-size: 0.65rem;\r\n    text-align: center;\r\n    flex: 1;\r\n    font-size: 13px !important;\r\n}\r\n\r\n/* Текст шага для десктопа */\r\n.stepTextDesktop {\r\n    font-size: 0.875rem;\r\n}\r\n\r\n/* Активный текст шага */\r\n.stepTextActive {\r\n    color: var(--primary-color);\r\n}\r\n\r\n/* Контейнер для Stepper */\r\n.stepperContainer {\r\n    width: 100%;\r\n    padding: 0;\r\n}\r\n\r\n/* Стили для Stepper */\r\n.stepper {\r\n    padding: 0;\r\n}\r\n\r\n/* Стили для шага */\r\n.stepperStep {\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n/* Стили для иконки шага */\r\n.stepperIcon {\r\n    width: 20px;\r\n    height: 20px;\r\n    font-size: 0.75rem;\r\n    margin: 0;\r\n}\r\n\r\n/* Стили для иконки шага на десктопе */\r\n.stepperIconDesktop {\r\n    width: 24px;\r\n    height: 24px;\r\n    font-size: 1rem;\r\n}\r\n\r\n/* Стили для соединительной линии */\r\n.stepperConnectorLine {\r\n    min-height: 1px;\r\n    margin: 0;\r\n}\r\n\r\n/* Стили для соединительной линии на десктопе */\r\n.stepperConnectorLineDesktop {\r\n    min-height: 2px;\r\n}\r\n\r\n/* Стили для метки шага */\r\n.stepperLabel {\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.title {\r\n    color: #6F879C;\r\n    font-size: 20px;\r\n    font-weight: 500;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n/* Для уменьшения размера степпера */\r\n.stepperContainer .MuiStepper-root {\r\n    padding: 8px 0;\r\n}\r\n\r\n.stepperContainer .MuiStep-root {\r\n    padding: 0 4px;\r\n}\r\n\r\n.stepperContainer .MuiStepIcon-root {\r\n    width: 24px;\r\n    height: 24px;\r\n    font-size: 14px;\r\n}\r\n\r\n.btnBack {\r\n    text-transform: none !important;\r\n    display: flex;\r\n    align-content: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: row;\r\n    height: 70px;\r\n    gap: 10px;\r\n    color: var(--color-primary-30) !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainBox": `HealthAI-module__mainBox--oWnRP`,
	"container": `HealthAI-module__container--ztaQj`,
	"titleContainer": `HealthAI-module__titleContainer--_elyl`,
	"title": `HealthAI-module__title--WR_zp`,
	"stepsTextContainer": `HealthAI-module__stepsTextContainer--arCQc`,
	"stepText": `HealthAI-module__stepText--CZEsH`,
	"stepTextDesktop": `HealthAI-module__stepTextDesktop--gN5El`,
	"stepTextActive": `HealthAI-module__stepTextActive--tROpN`,
	"stepperContainer": `HealthAI-module__stepperContainer--vfGO0`,
	"stepper": `HealthAI-module__stepper--eGlQi`,
	"stepperStep": `HealthAI-module__stepperStep--K0FDE`,
	"stepperIcon": `HealthAI-module__stepperIcon--I3yQP`,
	"stepperIconDesktop": `HealthAI-module__stepperIconDesktop--ONFKj`,
	"stepperConnectorLine": `HealthAI-module__stepperConnectorLine--gieQ4`,
	"stepperConnectorLineDesktop": `HealthAI-module__stepperConnectorLineDesktop--exCGZ`,
	"stepperLabel": `HealthAI-module__stepperLabel--nCbIr`,
	"MuiStepper-root": `HealthAI-module__MuiStepper-root--uKj4X`,
	"MuiStep-root": `HealthAI-module__MuiStep-root--ReplF`,
	"MuiStepIcon-root": `HealthAI-module__MuiStepIcon-root--_NPGL`,
	"btnBack": `HealthAI-module__btnBack--V9Nus`
};
export default ___CSS_LOADER_EXPORT___;
